import React, { Component } from 'react';
import illustration from '../images/atom.svg'
import background from '../images/background.svg'
import part2 from '../images/part2.png';
import part1 from '../images/part1.png';
import arrow from '../images/arrow.svg';
import { animateScroll as scroll } from 'react-scroll';

export default class Intro extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
             
        }

        this.paralax = this.paralax.bind(this)
    }
    

    paralax(){
        let xBg = ((window.event.pageX / 18) - 120).toString()
        let yBg = ((window.event.pageY / 18 ) + 5).toString()
        let xF = ((window.event.pageX /14) - 90).toString()
        let yF = ((window.event.pageY /14) + 25).toString()
        xBg = xBg + "px"
        yBg = yBg + "px"
        xF = xF + "px"
        yF = yF + "px"
        this.refs.paralaxBg.style.left = xBg
        this.refs.paralaxBg.style.top = yBg
        this.refs.paralaxF.style.left = xF
        this.refs.paralaxF.style.top = yF
        console.log(window.event.pageX)
    }

    render() {
        return (
            <div className='intro' onMouseMove={this.paralax}>
                <div className="intro__decorate_top">
                    <img src={part2} alt="" className="intro__decorate"/>
                </div>
                <div className="intro__inner">
                    <div className="intro__text_container">
                        <p className="title">Бот химик</p>
                        <p className="subtitle">Ваш помошник <br></br> в изучении химии</p>
                        <p className="text">Бот химик это бот который может помочь вам в изучении <br></br> химии. У нашего бота нет аналогов и мы предостовляем <br></br> качественные услуги для любых клиентов бесплатно</p>
                        <a onClick={() => scroll.scrollTo(2000)} className="intro__btn">Начать</a>
                        <img src={arrow} alt="" className="intro__img_btn"/>
                    </div>
                    <div className='img_container'>
                        <img src={illustration} ref='paralaxF' alt="" className="intro__img1"/>
                        <img src={background} ref='paralaxBg' alt="" className="intro__img2"/>
                    </div>
                </div>
                <div className="intro__decorate_bottom">
                    <img src={part1} alt="" className="intro__decorate"/>
                </div>
            </div>
        )
    }
}
